import React from 'react';
import AmbassadorPageLayout from '../AmbassadorPageLayout';
import Paragraph from '../Paragraph';
import { Text } from 'library';
import AppStoreButton from '../../AppStoreButton';
import GoldBadge from '../GoldBadge';
import usePublicSessionTracking from 'parent-portal/shared/PublicSessionTracking';
import Callout from '../Callout';

export default function AmbassadorPostSignUpPage() {
    const { usePageLoadTracking } = usePublicSessionTracking('Ambassador Post Signup');

    usePageLoadTracking();

    return (
        <AmbassadorPageLayout>
            <div style={{ marginBottom: 40, marginTop: 40 }}>
                <Text variant="display" textStyle={{ marginBottom: 30 }}>
                    Welcome!
                </Text>
                <GoldBadge />
                <Paragraph>
                    Congratulations! You are now a Tandem Ambassador. You can get started by checking out your
                    ambassador dashboard, found in the Tandem app.
                </Paragraph>
                <Callout>Download Tandem</Callout>
                <AppStoreButton tracking="Ambassador Post Signup" />
            </div>
        </AmbassadorPageLayout>
    );
}
